import React from "react";
import { withAuth0 } from "@auth0/auth0-react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getWindow } from "ssr-window";

import { api } from "@/utils/api";
import url from "@/utils/url";
import auth from "@/utils/auth";
import {
  getToken,
  setToken,
  removeToken,
  setSecureToken4FirstLogin,
} from "@/utils/cookies";
import {
  send as sendBroadcast,
  subscribe as subscribeBroadcast,
  close as closeBroadcast,
} from "@/utils/broadcast";
import { parse, isMiniSize, isEmpty, isPOC } from "@/utils";
import config from "@/utils/config";
import {
  eventEnum,
  authStateEnum,
  firstLoginStatusEnum,
  updateStatusEnum,
  auth0ErrorEnum,
  interceptorTypeEnum,
  BroadcastChannelTypeEnum,
} from "@/utils/enum";
import {
  updateAuthState as updateAuthStateDispatch,
  updateAuthentication as updateAuthenticationDispatch,
  updateFirstLoginStatus as updateFirstLoginStatusDispatch,
  updateCompanyUpdateStatus as updateCompanyUpdateStatusDispatch,
  updateUserProfileUpdateStatus as updateUserProfileUpdateStatusDispatch,
  updateAgreementStatusInfo as updateAgreementStatusInfoDispatch,
  updateBMMenuState as updateBMMenuStateDispatch,
  getHeaderInfo as getHeaderInfoDispatch,
  getCompanyInfo as getCompanyInfoDispatch,
  getBmInfo as getBmInfoDispatch,
  getMenuAuthorityInfo as getMenuAuthorityInfoDispatch,
  logout as logoutDispatch,
  coreLogout as coreLogoutDispatch,
  removeRedis as removeRedisDispatch,
} from "@/models/user";
import {
  updateWindow as updateWindowDispatch,
  updateNavigationTitle as updateNavigationTitleDispatch,
  updateNavigationMobileTitle as updateNavigationMobileTitleDispatch,
  updateAppState as updateAppStateDispatch,
} from "@/models/config";

class AuthHandler extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isLogout: false };

    //this.auth0Error = undefined;
    this.isSetting = false;
    this.shouldGetUserProfileUpdateStatus = false;
    this.ssrWindow = getWindow();
    this.ignorePageList = config.ignorePageList;
    this.checkUserInterval = undefined;
    this.isRefreshing = false;
    this.refreshList = [];
    this.isLogin = false;
    // 課金-ADD-START
    this.isFinish = false;
    // 課金-ADD-END
    this.init();
  }

  componentDidMount() {
    // add event listener
    this.addEventListener();
    // subscribe broadcast
    this.subscribeBroadcast();
  }

  componentWillUnmount() {
    // remove event listener
    this.removeEventListener();
    // close broadcast channel
    this.closeBroadcast();
    // clearInterval
    this.clearInterval();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.authState === authStateEnum.other) {
      return false;
    }
    const { isLogout } = this.state;
    if (
      (isLogout !== nextState.isLogout && nextState.isLogout) ||
      this.shouldNext(nextProps)
    ) {
      return true;
    }
    const {
      authState,
      firstLoginStatus,
      companyUpdateStatus,
      userProfileUpdateStatus,
      agreementStatusInfo,
      // 課金-ADD-START
      contractInfo,
      getHeaderInfo,
      // 課金-ADD-END
      location: { pathname },
      auth0: { isLoading },
    } = this.props;
    if (
      (authState === authStateEnum.other &&
        nextProps.authState === authStateEnum.notCertified) ||
      // 課金-ADD-START
      this.isFinish
      // 課金-ADD-END
    ) {
      return true;
    }
    if (
      authState !== nextProps.authState &&
      nextProps.authState !== authStateEnum.notCertified
    ) {
      // windowの情報を更新します
      this.updateSitecoreExternal();
      // ユーザ存在チェック
      this.checkUserExist();
      if (nextProps.authState === authStateEnum.auth0) {
        // 規約同意取得処理
        this.getAgreementStatus();
      }
      if (nextProps.authState === authStateEnum.web) {
        // 企業プロフィール更新有無取得処理
        this.getCompanyUpdateStatus();
      }
      return false;
    }
    if (nextProps.authState === authStateEnum.auth0) {
      if (!nextProps.agreementStatusInfo) {
        return false;
      }
      if (agreementStatusInfo !== nextProps.agreementStatusInfo) {
        // 課金-UPD-START
        // 契約情報取得処理
        getHeaderInfo();
        return false;
        // 課金-UPD-END
      }
      // 課金-ADD-START
      const nextContractInfo = nextProps.contractInfo;
      if (!nextContractInfo) {
        return false;
      }
      if (contractInfo !== nextContractInfo) {
        return this.shouldChangeAgreement(nextProps);
      }
      // 課金-ADD-END
      const termsAgreementInfo =
        nextProps.agreementStatusInfo?.termsAgreementInfo;
      if (
        isEmpty(termsAgreementInfo?.termsOfServiceVer) ||
        // 課金-ADD-START
        (nextContractInfo?.isPayment &&
          isEmpty(termsAgreementInfo?.bmSupportPlanTermsOfServiceVer) &&
          isEmpty(termsAgreementInfo?.privacyPolicyVer)) ||
        // 課金-ADD-END
        isEmpty(termsAgreementInfo?.privacyPolicyVer) ||
        isEmpty(termsAgreementInfo?.contactFeatureVer)
      ) {
        return this.changeAgreementIntercept(nextProps);
      }
      if (nextProps.firstLoginStatus === firstLoginStatusEnum.other) {
        return false;
      }
      if (firstLoginStatus !== nextProps.firstLoginStatus) {
        return this.shouldChangePassword(nextProps);
      }
      if (nextProps.firstLoginStatus === firstLoginStatusEnum.first) {
        return this.changePasswordIntercept(nextProps);
      }
      if (nextProps.firstLoginStatus === firstLoginStatusEnum.notFirst) {
        if (nextProps.companyUpdateStatus === updateStatusEnum.other) {
          return false;
        }
        if (companyUpdateStatus !== nextProps.companyUpdateStatus) {
          return this.shouldCompanyUpdate(nextProps);
        }
        if (nextProps.companyUpdateStatus === updateStatusEnum.notUpdate) {
          return this.companyUpdateIntercept(nextProps);
        }
        if (nextProps.companyUpdateStatus === updateStatusEnum.updated) {
          if (this.shouldGetUserProfileUpdateStatus) {
            if (nextProps.userProfileUpdateStatus === updateStatusEnum.other) {
              return false;
            }
            if (userProfileUpdateStatus !== nextProps.userProfileUpdateStatus) {
              return this.shouldUserUpdate(nextProps);
            }
            if (
              nextProps.userProfileUpdateStatus === updateStatusEnum.notUpdate
            ) {
              return this.userUpdateIntercept(nextProps);
            }
            if (
              nextProps.userProfileUpdateStatus === updateStatusEnum.updated
            ) {
              return this.routerIntercept(nextProps);
            }
          } else {
            return this.routerIntercept(nextProps);
          }
        }
      }
      return true;
    }
    if (nextProps.authState === authStateEnum.web) {
      if (nextProps.companyUpdateStatus === updateStatusEnum.other) {
        return false;
      }
      if (companyUpdateStatus !== nextProps.companyUpdateStatus) {
        return this.shouldCompanyUpdate(nextProps);
      }
      if (nextProps.companyUpdateStatus === updateStatusEnum.notUpdate) {
        return this.companyUpdateIntercept(nextProps);
      }
      if (nextProps.companyUpdateStatus === updateStatusEnum.updated) {
        if (this.shouldGetUserProfileUpdateStatus) {
          if (nextProps.userProfileUpdateStatus === updateStatusEnum.other) {
            return false;
          }
          if (userProfileUpdateStatus !== nextProps.userProfileUpdateStatus) {
            return this.shouldUserUpdate(nextProps);
          }
          if (
            nextProps.userProfileUpdateStatus === updateStatusEnum.notUpdate
          ) {
            return this.userUpdateIntercept(nextProps);
          }
          if (nextProps.userProfileUpdateStatus === updateStatusEnum.updated) {
            return this.routerIntercept(nextProps);
          }
        } else {
          return this.routerIntercept(nextProps);
        }
      }
    }
    if (nextProps.authState === authStateEnum.notCertified) {
      if (
        isLoading !== nextProps.auth0.isLoading &&
        !nextProps.auth0.isLoading
      ) {
        return true;
      }
      const urlList = this.ignorePageList
        .filter((item) => !item.requireAuth)
        .map((item) => item.url);
      // TDS_CMS-422
      if (
        urlList.find((item) =>
          pathname !== url.lp
            ? item !== url.lp && pathname.indexOf(item) === 0
            : item === url.lp
        )
      ) {
        return true;
      }
    }
    return false;
  }

  // init
  init = () => {
    // windowの情報を更新します
    this.updateSitecoreExternal();
    const {
      updateAppState,
      location: { search, pathname, hash },
    } = this.props;
    // auth0 error
    const error = parse("error", search);
    if (error === auth0ErrorEnum.unauthorized.error) {
      this.auth0Error();
      return;
    }

    // redirect auth0(bookmark login url redirect deal)
    const auth0Redirect = parse("iss", search);
    if (auth0Redirect) {
      this.auth0Login();
      return;
    }

    let path = `${pathname}${hash}`;
    // ユーザーログインの偽装
    const userCode = parse("user_cd", search);
    const token = parse("token", search);
    if (userCode && token) {
      path = url.home;
      getToken() && removeToken();
    }
    // TDS_PMO-1867 ホーム以外の場合、URLのパラメータをappStateに保存
    let urlSearch = path === url.home || path === `${url.home}/` ? "" : search;
    // urlの保存
    updateAppState({
      appState: { redirectUri: path, redirectSearch: urlSearch },
    });
    // 認証状態を更新します
    this.updateAuthInfo();
  };

  // add event listener
  addEventListener = () => {
    // イベントのイベントリスナーの追加
    config.eventEmitter.addListener(eventEnum.logout, this.logout);
    // 500エラーイベントのイベントリスナーの追加
    config.eventEmitter.addListener(
      eventEnum.internetError,
      this.internetError
    );
    // 400のイベントリスナーの追加
    config.eventEmitter.addListener(eventEnum.fourHundred, this.fourHundred);
    // 403のイベントリスナーの追加
    config.eventEmitter.addListener(eventEnum.forbidden, this.forbidden);
    // 404のイベントリスナーの追加
    config.eventEmitter.addListener(eventEnum.notFound, this.notFound);
    // ログインのイベントリスナーの追加
    config.eventEmitter.addListener(eventEnum.login, this.auth0Login);
    // refresh token
    config.eventEmitter.addListener(eventEnum.refreshToken, this.refreshToken);
    // 課金-ADD-START
    // update authentication
    config.eventEmitter.addListener(
      eventEnum.updateAuthentication,
      this.updateAuthentication
    );
    // 課金-ADD-END
  };

  // subscribe broadcast
  subscribeBroadcast = () => {
    subscribeBroadcast(({ data }) => {
      if (data?.action === BroadcastChannelTypeEnum.updateHeaderInfo) {
        const { getHeaderInfo } = this.props;
        // 共通ヘッダー情報取得処理
        getHeaderInfo();
      } else if (data?.action === BroadcastChannelTypeEnum.logout) {
        // ログアウト
        this.logout();
      }
    });
  };

  // remove event listener
  removeEventListener = () => {
    // イベントのイベントリスナーの削除
    config.eventEmitter.removeListener(eventEnum.logout, this.logout);
    // 500エラーイベントのイベントリスナーの削除
    config.eventEmitter.removeListener(
      eventEnum.internetError,
      this.internetError
    );
    // 400のイベントリスナーの削除
    config.eventEmitter.removeListener(eventEnum.fourHundred, this.fourHundred);
    // 403のイベントリスナーの削除
    config.eventEmitter.removeListener(eventEnum.forbidden, this.forbidden);
    // 404のイベントリスナーの削除
    config.eventEmitter.removeListener(eventEnum.notFound, this.notFound);
    // ログインのイベントリスナーの削除
    config.eventEmitter.removeListener(eventEnum.login, this.auth0Login);
    // refresh token
    config.eventEmitter.removeListener(
      eventEnum.refreshToken,
      this.refreshToken
    );
    // 課金-ADD-START
    // update authentication
    config.eventEmitter.removeListener(
      eventEnum.updateAuthentication,
      this.updateAuthentication
    );
    // 課金-ADD-END
  };

  // close broadcast
  closeBroadcast = () => {
    closeBroadcast();
  };

  // clearInterval
  clearInterval = () => {
    this.checkUserInterval && clearInterval(this.checkUserInterval);
  };

  // windowの情報を更新します
  updateSitecoreExternal = () => {
    const {
      updateWindow,
      updateNavigationTitle,
      updateNavigationMobileTitle,
      updateFirstLoginStatus,
      updateCompanyUpdateStatus,
      updateUserProfileUpdateStatus,
      updateBMMenuState,
      getHeaderInfo,
      history,
    } = this.props;
    updateWindow({
      history,
    });
    if (this.ssrWindow?.sitecoreExternal) {
      this.ssrWindow.sitecoreExternal.setHeaderTitle = (navigationTitle) => {
        isMiniSize()
          ? updateNavigationMobileTitle({
              navigationMobileTitle: navigationTitle,
            })
          : updateNavigationTitle({ navigationTitle });
      };
      this.ssrWindow.sitecoreExternal.updateHeaderInfo = () => {
        getHeaderInfo();
      };
      this.ssrWindow.sitecoreExternal.logout = () => {
        this.logout();
      };
      this.ssrWindow.sitecoreExternal.changePasswordStatus = () => {
        updateFirstLoginStatus({
          firstLoginStatus: firstLoginStatusEnum.notFirst,
        });
      };
      this.ssrWindow.sitecoreExternal.changeCompanyInfoStatus = (isSetting) => {
        this.isSetting = isSetting;
        updateCompanyUpdateStatus({
          companyUpdateStatus: updateStatusEnum.updated,
        });
        updateUserProfileUpdateStatus({
          userProfileUpdateStatus: updateStatusEnum.updated,
        });
      };
      this.ssrWindow.sitecoreExternal.changeUserProfileStatus = (isSetting) => {
        this.isSetting = isSetting;
        updateUserProfileUpdateStatus({
          userProfileUpdateStatus: updateStatusEnum.updated,
        });
      };
      this.ssrWindow.sitecoreExternal.setBMMenuState = (state) => {
        updateBMMenuState({ BMMenuState: state });
      };
      this.ssrWindow.sitecoreExternal.refreshToken = (callback) => {
        this.refreshToken(callback);
      };
    }
  };

  // auth0 error
  auth0Error = async () => {
    try {
      const {
        location: { search },
      } = this.props;
      const error = parse("error", search);
      if (error === auth0ErrorEnum.unauthorized.error) {
        const errorDescription = parse("error_description", search);
        if (
          errorDescription.indexOf(
            auth0ErrorEnum.unauthorized.description.deniedIP
          ) === 0
        ) {
          const { coreLogout } = this.props;
          // coreログアウト処理
          await coreLogout();
        }
        this.ssrWindow.location.href = `${auth.audience.replace(
          "/api",
          ""
        )}logout?returnTo=${this.ssrWindow.location.origin}${
          url.auth0UnauthorizedReturnTo
        }`;
      }
    } catch (error) {
      console.error("core logout error = " + error);
    }
  };

  // 404,500止めないで
  shouldNext = (nextProps) => {
    const {
      location: { pathname },
    } = nextProps;
    const urlList = this.ignorePageList
      .filter((item) => item.type === interceptorTypeEnum.common)
      .map((item) => item.url);
    return urlList.indexOf(pathname) !== -1;
  };

  // ページジャンプ
  toPath = (to, next = url.home) => {
    const {
      appState,
      history: { replace },
    } = this.props;
    // TDS_PMO-1867 偽装ユーザ、ラベルの場合、URLパラメータ設定
    let path = to
      ? to
      : appState?.redirectUri
      ? `${appState?.redirectUri}${appState?.redirectSearch}`
      : next;
    const urlList = this.ignorePageList
      .filter((item) => item.type !== interceptorTypeEnum.common)
      .map((item) => item.url);
    const tempPath = path.split("?")[0];
    // TDS_CMS-422
    if (
      urlList.find((item) =>
        tempPath !== url.lp
          ? item !== url.lp && tempPath.indexOf(item) === 0
          : item === url.lp
      )
    ) {
      path = url.home;
    }
    replace(path);
  };

  // ルーティングブロック
  routerIntercept = (nextProps) => {
    const { children } = nextProps;
    const itemId = children.props?.route?.itemId;
    const templateName = children.props?.route?.templateName;
    // lp
    const itemIdList = this.ignorePageList
      .filter(
        (item) => item.type === interceptorTypeEnum.lp && !item.templateName
      )
      .map((item) => item.itemId);
    const templateNameList = this.ignorePageList
      .filter(
        (item) => item.type === interceptorTypeEnum.lp && item.templateName
      )
      .map((item) => item.templateName);
    if (
      itemIdList.indexOf(itemId) !== -1 ||
      templateNameList.indexOf(templateName) !== -1
    ) {
      return false;
    }
    return true;
  };

  changeAgreementIntercept = (nextProps) => {
    const {
      children,
      // 課金-ADD-START
      contractInfo,
      // 課金-ADD-END
    } = nextProps;
    const itemId = children.props?.route?.itemId;
    const pageList = this.ignorePageList.filter(
      (item) => item.type === interceptorTypeEnum.confirmSubTerms
    );
    const itemIdList = pageList.map((item) => item.itemId);
    const termsAgreementInfo = nextProps.agreementStatusInfo.termsAgreementInfo;
    if (isEmpty(termsAgreementInfo.termsOfServiceVer)) {
      if (itemIdList[0] === itemId) {
        return true;
      }
    }
    // 課金-ADD-START
    else if (
      contractInfo.isPayment &&
      isEmpty(termsAgreementInfo.bmSupportPlanTermsOfServiceVer) &&
      isEmpty(termsAgreementInfo.privacyPolicyVer)
    ) {
      if (itemIdList[1] === itemId) {
        return true;
      }
    }
    // 課金-ADD-END
    else if (isEmpty(termsAgreementInfo.privacyPolicyVer)) {
      if (itemIdList[2] === itemId) {
        return true;
      }
    } else if (isEmpty(termsAgreementInfo.contactFeatureVer)) {
      if (itemIdList[3] === itemId) {
        return true;
      }
    }
    return false;
  };

  // パスワードの変更
  changePasswordIntercept = (nextProps) => {
    const { children } = nextProps;
    const itemId = children.props?.route?.itemId;
    const pageList = this.ignorePageList.filter(
      (item) => item.type === interceptorTypeEnum.initialPassword
    );
    const itemIdList = pageList.map((item) => item.itemId);
    if (itemIdList.indexOf(itemId) !== -1) {
      return true;
    }
    return false;
  };

  // 企業情報の変更
  companyUpdateIntercept = (nextProps) => {
    const { children } = nextProps;
    const itemId = children.props?.route?.itemId;
    const pageList = this.ignorePageList.filter(
      (item) => item.type === interceptorTypeEnum.initialCompany
    );
    const itemIdList = pageList.map((item) => item.itemId);
    if (itemIdList.indexOf(itemId) !== -1) {
      return true;
    }
    return false;
  };

  // ユーザー情報の変更
  userUpdateIntercept = (nextProps) => {
    const { children } = nextProps;
    const itemId = children.props?.route?.itemId;
    const pageList = this.ignorePageList.filter(
      (item) => item.type === interceptorTypeEnum.initialUser
    );
    const itemIdList = pageList.map((item) => item.itemId);
    if (itemIdList.indexOf(itemId) !== -1) {
      return true;
    }
    return false;
  };

  // [ユーザー追加] 利用規約 or [ユーザー追加] BM支援プラン利用規約バージョン or [ユーザー追加] プライバシーポリシー or [ユーザー追加] 問合せ機能について or パスワード処理をリセット
  shouldChangeAgreement = (nextProps) => {
    const {
      history: { replace },
      // 課金-ADD-START
      contractInfo,
      // 課金-ADD-END
    } = nextProps;
    const termsAgreementInfo = nextProps.agreementStatusInfo.termsAgreementInfo;
    if (isEmpty(termsAgreementInfo.termsOfServiceVer)) {
      // [ユーザー追加] 利用規約
      replace(url.confirmSubAgreement);
    }
    // 課金-ADD-START
    else if (
      contractInfo.isPayment &&
      isEmpty(termsAgreementInfo.bmSupportPlanTermsOfServiceVer) &&
      isEmpty(termsAgreementInfo.privacyPolicyVer)
    ) {
      // [ユーザー追加] BM支援プラン利用規約バージョン
      replace(url.confirmSubPaymentAgreement);
    }
    // 課金-ADD-END
    else if (isEmpty(termsAgreementInfo.privacyPolicyVer)) {
      // [ユーザー追加] プライバシーポリシー
      replace(url.confirmSubPrivacyPolicy);
    } else if (isEmpty(termsAgreementInfo.contactFeatureVer)) {
      // [ユーザー追加] 問合せ機能について
      replace(url.confirmSubInquiry);
    } else {
      // パスワード処理をリセット
      this.getFirstLoginStatus();
    }
    return false;
  };

  // パスワードの変更 or 企業プロフィール更新有無取得処理 or ユーザープロフィール更新有無取得処理
  shouldChangePassword = (nextProps) => {
    const {
      history: { replace },
    } = nextProps;
    if (nextProps.firstLoginStatus === firstLoginStatusEnum.first) {
      // パスワードの変更
      replace(url.initialPasswordEdit);
    } else {
      // 企業プロフィール更新有無取得処理
      this.getCompanyUpdateStatus();
    }
    return false;
  };

  // 企業情報の変更 or 共通情報取得
  shouldCompanyUpdate = (nextProps) => {
    const {
      history: { replace },
    } = nextProps;
    const { companyUpdateStatus } = this.props;
    if (nextProps.companyUpdateStatus === updateStatusEnum.notUpdate) {
      // 企業情報の変更
      replace(url.initialCompanyInfoEdit);
    } else {
      if (companyUpdateStatus === updateStatusEnum.other) {
        // ユーザープロフィール更新有無取得処理
        this.shouldGetUserProfileUpdateStatus = true;
        this.getUserProfileUpdateStatus();
      } else {
        // 共通情報取得
        this.getCommonInfo();
        // トップページ
        this.toPath(this.isSetting && url.settingsCorpProfileEdit);
      }
    }
    return false;
  };

  // ユーザー情報の変更 or 共通情報取得
  shouldUserUpdate = (nextProps) => {
    const {
      history: { replace },
    } = nextProps;
    if (nextProps.userProfileUpdateStatus === updateStatusEnum.notUpdate) {
      // ユーザー情報の変更
      replace(url.initialUserInfoEdit);
    } else {
      // 共通情報取得
      this.getCommonInfo();
      // トップページ
      this.toPath(this.isSetting && url.settingsUserProfileEdit);
    }
    return false;
  };

  // パスワード処理をリセット
  getFirstLoginStatus = async () => {
    try {
      const { updateFirstLoginStatus, authentication } = this.props;
      if (!isPOC()) {
        let loginInfo = await api.user.getLoginInfo({
          accountId: authentication?.accountId,
          accessToken: authentication?.token,
          updateFlag: updateStatusEnum.notUpdate,
        });
        let firstLoginStatus = loginInfo?.firstLoginFlag;
        if (firstLoginStatus === firstLoginStatusEnum.first) {
          // 初回ログイン
          setSecureToken4FirstLogin(loginInfo?.secureToken);
          updateFirstLoginStatus({ firstLoginStatus });
        } else {
          loginInfo = await api.user.getLoginInfo({
            accountId: authentication?.accountId,
            accessToken: authentication?.token,
            updateFlag: updateStatusEnum.updated,
          });
          firstLoginStatus = loginInfo?.firstLoginFlag;
          if (firstLoginStatus === firstLoginStatusEnum.first) {
            // 初回ログイン
            setSecureToken4FirstLogin(loginInfo?.secureToken);
          }
          updateFirstLoginStatus({ firstLoginStatus });
        }
      } else {
        updateFirstLoginStatus({
          firstLoginStatus: "0",
        });
      }
    } catch (error) {
      console.error("getFirstLoginStatus error = " + error);
    }
  };

  // 規約同意取得処理
  getAgreementStatus = async () => {
    try {
      const { updateAgreementStatusInfo, authentication } = this.props;
      if (!isPOC()) {
        // TDS_PMO-1776　TASp0016　入会バージョン情報取得処理
        this.ssrWindow.sitecoreExternal.membershipVersion = (
          await api.user.getCustomersVersion()
        )?.membershipVersion;
        const agreementStatusInfo = await api.user.getAgreementStatus({
          accountId: authentication?.accountId,
          accessToken: authentication?.token,
        });
        updateAgreementStatusInfo({ agreementStatusInfo });
      } else {
        updateAgreementStatusInfo({
          agreementStatusInfo: {
            termsAgreementInfo: {
              termsOfServiceVer: "1.0",
              privacyPolicyVer: "1.0",
              contactFeatureVer: "1.0",
              bmSupportPlanTermsOfServiceVer: "1.0",
            },
          },
        });
      }
    } catch (error) {
      console.error("getAgreementStatus error = " + error);
    }
  };

  // 企業プロフィール更新有無取得処理
  getCompanyUpdateStatus = async () => {
    try {
      const { updateCompanyUpdateStatus, authentication } = this.props;
      const companyUpdateStatus = (
        await api.user.getCompanyInfoModificationExistence({
          accountId: authentication?.accountId,
          accessToken: authentication?.token,
        })
      ).changeCompanyInfoFlag;
      updateCompanyUpdateStatus({ companyUpdateStatus });
    } catch (error) {
      console.error("getCompanyUpdateStatus error = " + error);
    }
  };

  // ユーザープロフィール更新有無取得処理
  getUserProfileUpdateStatus = async () => {
    try {
      const { updateUserProfileUpdateStatus, authentication } = this.props;
      if (!isPOC()) {
        const userProfileUpdateStatus = (
          await api.user.getUserProfileInfo({
            accountId: authentication?.accountId,
            accessToken: authentication?.token,
          })
        )?.userProfileInfo?.companyAccountInfoUpdateFlag;
        updateUserProfileUpdateStatus({ userProfileUpdateStatus });
      } else {
        updateUserProfileUpdateStatus({ userProfileUpdateStatus: "1" });
      }
    } catch (error) {
      console.error("getUserProfileUpdateStatus error = " + error);
    }
  };

  // 共通情報取得
  getCommonInfo = () => {
    const {
      getHeaderInfo,
      getCompanyInfo,
      getBmInfo,
      getMenuAuthorityInfo,
      authState,
    } = this.props;
    // 課金-ADD-START
    if (authState === authStateEnum.auth0) {
      this.isFinish = true;
    }
    // 課金-ADD-END
    // 共通ヘッダー情報取得処理
    getHeaderInfo();
    // 企業情報取得処理
    getCompanyInfo();
    // BM利用停止フラグ取得
    getBmInfo();
    // アカウント権限情報取得
    getMenuAuthorityInfo();
    // send update header info broadcast
    sendBroadcast(BroadcastChannelTypeEnum.updateHeaderInfo);
  };

  // 認証状態を更新します
  updateAuthInfo = () => {
    const { updateAuthState, updateAuthentication } = this.props;
    // token更新します
    updateAuthentication();
    // 認証状態を更新します
    updateAuthState();
  };

  // 課金-ADD-START
  updateAuthentication = () => {
    const { updateAuthentication } = this.props;
    // token更新します
    updateAuthentication();
  };
  // 課金-ADD-END

  // ログアウト
  logout = () => {
    const { isLogout } = this.state;
    if (!isLogout) {
      const {
        auth0: { logout: auth0Logout },
        coreLogout,
        removeRedis,
      } = this.props;
      (async () => {
        try {
          this.setState({ isLogout: true });
          // coreログアウト処理
          await coreLogout();
          // tokenをクリア
          getToken() && removeToken();
          // remove redis
          await removeRedis();
          // 認証状態を更新します
          this.updateAuthInfo();
          // ClearAuthenticationCache
          document.execCommand("ClearAuthenticationCache", "false");
          // send logout broadcast
          sendBroadcast(BroadcastChannelTypeEnum.logout);
          // auth0 ログアウト処理
          auth0Logout({ returnTo: this.ssrWindow?.location?.origin });
        } catch (error) {
          console.error("auth0 logout error = " + error);
        }
      })();
    }
  };

  // ユーザ存在チェック
  checkUserExist = () => {
    this.checkUserInterval = setInterval(() => {
      if (this.isRefreshing) {
        return;
      }
      (async () => {
        try {
          const isExist = (await api.user.checkUserExist())?.exists;
          if (!isExist) {
            this.logout();
          }
        } catch (error) {
          console.error("checkUserExist error = " + error);
        }
      })();
    }, 1000 * 60);
  };

  // 500エラー
  internetError = () => {
    const {
      history: { replace },
      location: { pathname },
    } = this.props;
    if (pathname !== url.internetError) {
      replace(url.internetError);
    }
  };

  // 400
  fourHundred = () => {
    const {
      history: { replace },
      location: { pathname },
    } = this.props;
    if (pathname !== url.fourHundred) {
      replace(url.fourHundred);
    }
  };

  // 403
  forbidden = () => {
    const {
      history: { replace },
      location: { pathname },
    } = this.props;
    if (pathname !== url.forbidden) {
      replace(url.forbidden);
    }
  };

  // 404
  notFound = () => {
    const {
      history: { replace },
      location: { pathname },
    } = this.props;
    if (pathname !== url.notFound) {
      replace(url.notFound);
    }
  };

  // auth0 ログイン
  auth0Login = () => {
    const {
      auth0: { loginWithRedirect },
      appState,
    } = this.props;
    loginWithRedirect({
      redirectUri: `${this.ssrWindow?.location?.origin}${url.home}`,
      appState,
    });
  };

  // redirect lp
  redirectLP = () => {
    const {
      history: { replace },
      location: { pathname },
    } = this.props;
    if (pathname !== url.lp) {
      replace(url.lp);
    }
  };

  // redirect confirmAgreement
  redirectConfirmAgreement = () => {
    const {
      history: { replace },
      location: { pathname },
    } = this.props;
    if (
      pathname !== url.confirmAgreement &&
      (pathname === url.register || pathname === `${url.register}/`)
    ) {
      replace(url.confirmAgreement);
    }
  };

  // refresh token
  refreshToken = (callback) => {
    const {
      auth0: { getAccessTokenSilently },
      authentication,
    } = this.props;
    if (this.isRefreshing) {
      this.refreshList.push(callback);
      return;
    }
    if (
      authentication?.updateTime &&
      Date.now() - authentication?.updateTime <= config.minTokenRequestInterval
    ) {
      callback && callback(authentication?.token);
      return;
    }
    this.isRefreshing = true;
    api.user
      .coreLogout()
      .then(() => {
        return getAccessTokenSilently({
          detailedResponse: true,
          ignoreCache: true,
        });
      })
      .then((response) => {
        const token = response?.id_token;
        if (token && authentication) {
          return api.auth0
            .setToken({
              key: authentication.accountId,
              token,
            })
            .then(() => {
              return token;
            });
        }
        this.isRefreshing = false;
        return Promise.reject();
      })
      .then((token) => {
        const { updateAuthentication, updateWindow } = this.props;
        const newAuthentication = {
          ...authentication,
          token,
          updateTime: Date.now(),
        };
        setToken(newAuthentication);
        updateAuthentication({
          authentication: newAuthentication,
        });
        updateWindow({
          authentication: newAuthentication,
        });
        this.refreshList.forEach((item) => {
          item && item(token);
        });
        this.refreshList = [];
        this.isRefreshing = false;
        callback && callback(token);
      })
      .catch(() => {
        this.refreshList.forEach((item) => {
          item && item();
        });
        this.refreshList = [];
        this.isRefreshing = false;
        callback && callback();
      });
  };

  // 認証成功リターンオリジナルページ
  children = () => {
    this.redirectConfirmAgreement();
    const { children } = this.props;
    return children;
  };

  // auth0 エラー情報
  auth0ErrorInfo = (error) => {
    console.error("auth0 error..." + JSON.stringify(error));
    if (auth0ErrorEnum.invalidState.message === error.message) {
      this.auth0Login();
      return <div />;
    }
    return <div>auth0 error... {JSON.stringify(error)}</div>;
  };

  // log info
  logInfo = (message = "") => {
    console.log(`${message} info...`);
    return <div />;
  };

  // auth0 ログイン
  auth0 = () => {
    const {
      auth0: {
        isAuthenticated,
        error,
        user,
        isLoading,
        // getAccessTokenSilently,
        getIdTokenClaims,
      },
      coreLogout,
    } = this.props;
    if (isLoading) {
      return this.logInfo("auth0 loading");
    }
    if (error) {
      return this.auth0ErrorInfo(error);
    }
    if (!isAuthenticated) {
      // TDS_CMS-422 ホームの場合、LPページ画面に遷移しないで、Auth0に遷移する
      // if (pathname === url.home) {
      //   this.redirectLP();
      // } else {
      this.auth0Login();
      // }
      return this.logInfo(
        // pathname === url.home ? "redirect lp" : "auth0 login"
        "auth0 login"
      );
    }
    (async () => {
      try {
        // 認証トークンを取得する
        const token = (await getIdTokenClaims()).__raw;

        // const token = await getAccessTokenSilently();

        const accountId = user?.sub?.replace("auth0|", "");

        // サーバにトークンを送信する
        await api.auth0.setToken({
          key: accountId,
          token,
        });

        // トークンをlocalstorageに保存する
        setToken({
          accountId,
          token,
          type: authStateEnum.auth0,
          updateTime: Date.now(),
        });

        // coreログアウト処理
        await coreLogout();

        // 認証状態を更新します
        this.updateAuthInfo();
      } catch (e) {
        console.error("auth0 login error = " + e);
      }
    })();

    return this.logInfo("auth0 get token");
  };

  // web ログイン
  webLogin = (userCode, token) => {
    (async () => {
      try {
        // coreログイン処理
        await api.user.coreLogin(
          null,
          JSON.stringify({
            userCd: userCode,
            token,
          })
        );

        // にユーザーコードを保存する
        await api.auth0.setUserCode({
          usercd: userCode,
          token,
        });

        // localstorageにユーザーコードを保存する
        setToken({
          accountId: userCode,
          token,
          type: authStateEnum.web,
          updateTime: Date.now(),
        });

        // 認証状態を更新します
        this.updateAuthInfo();
      } catch (error) {
        console.error("web login error = " + error);
      }
    })();

    return this.logInfo("web login");
  };

  render() {
    const {
      location: { pathname, search },
      authState,
    } = this.props;
    if (authState === authStateEnum.other) {
      return this.logInfo("init");
    }
    const { isLogout } = this.state;
    if (isLogout) {
      return this.logInfo("logout");
    }
    const userCode = parse("user_cd", search);
    const token = parse("token", search);
    if (userCode && token && !this.isLogin) {
      this.isLogin = true;
      // ユーザーログインの偽装
      return this.webLogin(userCode, token);
    }
    if (
      authState === authStateEnum.auth0 ||
      authState === authStateEnum.web ||
      this.ignorePageList.filter(
        (item) =>
          !item.requireAuth &&
          (pathname !== url.lp
            ? item.url !== url.lp && pathname.indexOf(item.url) === 0
            : item.url === url.lp)
      ).length > 0
    ) {
      // 認証に成功しました
      return this.children();
    }
    // auth0 ログイン
    return this.auth0();
  }
}

const mapStateToProps = (state) => {
  return {
    authState: state?.user?.authState,
    authentication: state?.user?.authentication,
    firstLoginStatus: state?.user?.firstLoginStatus,
    companyUpdateStatus: state?.user?.companyUpdateStatus,
    agreementStatusInfo: state?.user?.agreementStatusInfo,
    userProfileUpdateStatus: state?.user?.userProfileUpdateStatus,
    appState: state?.config?.appState,
    // 課金-ADD-START
    contractInfo: state?.user?.contractInfo,
    // 課金-ADD-END
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAuthState: () => dispatch(updateAuthStateDispatch()),
    updateAuthentication: (action) =>
      dispatch(updateAuthenticationDispatch(action)),
    updateFirstLoginStatus: (action) =>
      dispatch(updateFirstLoginStatusDispatch(action)),
    updateCompanyUpdateStatus: (action) =>
      dispatch(updateCompanyUpdateStatusDispatch(action)),
    updateUserProfileUpdateStatus: (action) =>
      dispatch(updateUserProfileUpdateStatusDispatch(action)),
    updateAgreementStatusInfo: (action) =>
      dispatch(updateAgreementStatusInfoDispatch(action)),
    updateBMMenuState: (action) => dispatch(updateBMMenuStateDispatch(action)),
    getHeaderInfo: () => dispatch(getHeaderInfoDispatch()),
    getCompanyInfo: () => dispatch(getCompanyInfoDispatch()),
    getBmInfo: () => dispatch(getBmInfoDispatch()),
    getMenuAuthorityInfo: () => dispatch(getMenuAuthorityInfoDispatch()),
    logout: () => dispatch(logoutDispatch()),
    updateWindow: (action) => dispatch(updateWindowDispatch(action)),
    updateNavigationTitle: (action) =>
      dispatch(updateNavigationTitleDispatch(action)),
    updateNavigationMobileTitle: (action) =>
      dispatch(updateNavigationMobileTitleDispatch(action)),
    coreLogout: () => dispatch(coreLogoutDispatch()),
    removeRedis: () => dispatch(removeRedisDispatch()),
    updateAppState: (action) => dispatch(updateAppStateDispatch(action)),
  };
};

export default withRouter(
  withAuth0(connect(mapStateToProps, mapDispatchToProps)(AuthHandler))
);
